import {
  FlyExterminatorMaintenanceMonitorViewDTO,
  MaintenancePrice,
} from "@/services/backend/qpm/calculations/types/calculation";
import t from "@/lang/lang";
import {
  IntNumberInput,
  Value,
} from "@/shared/components/domain/qpm/inputs/number-input";
import { Label } from "@/shared/components/ui/label";

export type ServiceEntryComponentProps = {
  calculationId: string;
  maintenancePrice: MaintenancePrice;
  monitor?: FlyExterminatorMaintenanceMonitorViewDTO;
};

export function ServiceEntryComponent({
  calculationId,
  maintenancePrice,
  monitor,
}: ServiceEntryComponentProps) {
  const monitorLabel = monitor?.name ?? maintenancePrice.monitorId;

  return (
    <div className="flex items-center justify-between space-x-4 border-b px-4">
      <div className="grid h-12 w-full grid-cols-[300px_auto] items-center gap-4">
        <div className="truncate">{monitorLabel}</div>
        <div className="grid grid-cols-3 gap-4">
          <div className="flex items-center justify-start gap-2">
            <Label
              htmlFor={`${calculationId}-amount-input-${maintenancePrice.monitorId}`}
            >
              {t("Anzahl")}
            </Label>
            <IntNumberInput
              id={`${calculationId}-amount-input-${maintenancePrice.monitorId}`}
              value={maintenancePrice.amount}
              disabled
            />
          </div>

          <div className="flex items-center justify-start gap-2">
            <Label
              htmlFor={`${calculationId}-price-per-measure-input-${maintenancePrice.monitorId}`}
            >
              {t("Einzelpreis je Maßnahme pro Gerät")}
            </Label>
            <Value
              id={`${calculationId}-price-per-measure-input-${maintenancePrice.monitorId}`}
              value={maintenancePrice.pricePerMeasure}
              fractions={2}
            />
          </div>

          <div className="flex items-center justify-end gap-2">
            <Label
              htmlFor={`${calculationId}-measure-rate-per-monitor-input-${maintenancePrice.monitorId}`}
            >
              {t("Wartung inkl. Matrial pro Maßnahme")}
            </Label>
            <Value
              id={`${calculationId}-measure-rate-per-monitor-input-${maintenancePrice.monitorId}`}
              value={maintenancePrice.totalPriceMonitorPerMeasure}
              fractions={2}
            />
          </div>
        </div>
      </div>
    </div>
  );
}
